import { STORE_UNID_SURGERY_INFO } from 'src/pages/reportUsage/redux/action/types';

const updateStoredUnidInfoSurgeryDataUtil = (dispatch, unidSurgeryData, itemList) => {
    if (
        unidSurgeryData &&
        Object.keys(unidSurgeryData).length > 0 &&
        unidSurgeryData.unidProducts?.length > 0 &&
        unidSurgeryData.unidProducts.some(
            (uItem) => uItem.isDeletedItemChecked
        )
    ) {
        const deletedRodItems = unidSurgeryData.unidProducts.filter(
            (uItem) => uItem.isDeletedItemChecked
        );
        const productCFNs = itemList.map((x) => x.cfn || x.productCFN);
        if (
            deletedRodItems?.length > 0 &&
            deletedRodItems
                .map((x) => x.productCFN)
                .some((uCfn) => productCFNs.includes(uCfn))
        ) {
            const updatedUnidSurgeryData = { ...unidSurgeryData };
            updatedUnidSurgeryData.unidProducts.forEach((uItem, uIdx) => {
                if (
                    uItem.isDeletedItemChecked &&
                    productCFNs.includes(uItem.productCFN)
                ) {
                    updatedUnidSurgeryData.unidProducts[
                        uIdx
                    ].isDeletedItemChecked = false;
                }
            });
            dispatch({
                type: STORE_UNID_SURGERY_INFO,
                payload: updatedUnidSurgeryData,
            });
        }
    }
};

export default updateStoredUnidInfoSurgeryDataUtil;